module.exports = __webpack_public_path__ + "img/master.a88b8df2.svg";